import { create } from "zustand";

export const useMessagesStore = create((set) => ({
  dismissedMessages: [],
  setDismissed: (messageName) =>
    set((state) => ({
      dismissedMessages: [...state.dismissedMessages, messageName],
    })),
}));
